import './kaleis/style';
import FormStructure from './kaleis/form_structure';

export default FormStructure;